import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { TablerIconsModule } from 'angular-tabler-icons';
import { Sidebar2Component } from './sidebar-2/sidebar-2.component';
import { MatDialog } from '@angular/material/dialog';
import { ProfileComponent } from './profile/profile.component';
import { LocalStorageService } from 'src/app/core/services/localStorage/local-storage.service';
import { UpdatePasswordComponent } from './update-password/update-password.component';
import { ProfileService } from 'src/app/core/services/profile/profile.service';
import { LogoutDialogComponent } from '../../components/logout-dialog/logout-dialog.component';
import { ToastService } from '../../services/toast.service';

const MOBILE_VIEW = '(max-width: 768px)';

@Component({
  selector: 'app-full',
  standalone: true,
  imports: [
    RouterModule,
    MaterialModule,
    CommonModule,
    TablerIconsModule,
    Sidebar2Component
  ],
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FullComponent implements OnInit, OnDestroy {
  @ViewChild(Sidebar2Component) sidebarRef!: Sidebar2Component;

  isSideBarCollapsed: boolean = false;
  isMobileSidebarOpen: boolean = false;
  isMobileScreen: boolean = false;

  userId: any;
  profileDetail: any;
  profile: any;
  profileImage: any;

  private layoutChangesSubscription = Subscription.EMPTY;
  private routerEventsSubscription = Subscription.EMPTY;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private breakpointObserver: BreakpointObserver,
    private localStorageService: LocalStorageService,
    private profileService: ProfileService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW])
      .subscribe((state) => {
        this.isMobileScreen = state.matches;
      });

    this.routerEventsSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this.isMobileScreen && this.sidebarRef) {
          this.sidebarRef.closeMobile();
        }
      });

    this.userId = this.localStorageService.getUserId();
    this.profile = this.localStorageService.getProfile();
    this.profileImage = this.localStorageService.getProfileImg() || null;
    this.getProfileDetailById();
  }

  ngOnDestroy(): void {
    this.layoutChangesSubscription.unsubscribe();
    this.routerEventsSubscription.unsubscribe();
  }

  onSidebarToggled(collapsed: boolean): void {
    this.isSideBarCollapsed = collapsed;
  }

  getProfileDetailById(): void {
    if (!this.userId) return;
    this.profileService.getProfileById(this.userId).subscribe({
      next: (res: any) => {
        if (res.isSuccess) {
          this.profileDetail = res.item;
        }
      },
      error: (error: any) => {
        console.error('Error fetching profile:', error);
      }
    });
  }

  openProfileModel(): void {
    const dialogRef = this.dialog.open(ProfileComponent, {
      width: '100%',
      maxWidth: '520px',
      panelClass: 'custom-modal-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getProfileDetailById();
    });
  }

  openUpdatePasswordModel(): void {
    this.dialog.open(UpdatePasswordComponent, {
      width: '100%',
      maxWidth: '460px',
      panelClass: 'custom-modal-dialog'
    });
  }

  logout(): void {
    const dialogRef = this.dialog.open(LogoutDialogComponent, {
      width: '100%',
      maxWidth: '440px',
      panelClass: 'custom-modal-dialog'
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.localStorageService.logout();
        this.toastService.successToast('Logged out successfully');
      }
    });
  }
}
